import NFT from "./NFT";

export const apiNFT = NFT;
